import React from 'react';
import Section from '../layout/Section';
import SectionTitle from '../ui/SectionTitle';
import Marquee from '../ui/Marquee';
import TestimonialCard from '../ui/TestimonialCard';
import { testimonials } from '../../data/testimonials';

export default function TestimonialsSection() {
  const firstRow = testimonials.slice(0, 4);
  const secondRow = testimonials.slice(4, 8);

  return (
    <Section id="testimonials">
      <SectionTitle
        title="Ils l'ont fait, pourquoi pas vous ?"
        subtitle="Des commerçants sénégalais partagent leur expérience"
      />

      <div className="space-y-4 sm:space-y-6 -mx-4 sm:-mx-6 lg:-mx-8">
        {/* Row 1 - scrolls right */}
        <Marquee speed={35} dark={false} className="[&>div]:gap-6">
          {firstRow.map((testimonial, i) => (
            <TestimonialCard key={i} testimonial={testimonial} />
          ))}
        </Marquee>

        {/* Row 2 - scrolls left */}
        <Marquee speed={35} reverse dark={false} className="[&>div]:gap-6">
          {secondRow.map((testimonial, i) => (
            <TestimonialCard key={i} testimonial={testimonial} />
          ))}
        </Marquee>
      </div>
    </Section>
  );
}
